import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppState } from '@app/app.service';
import { IUserPlan, UserDeviceService, UserPlansService } from '@ztarmobile/zwp-service-backend';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { takeWhile } from 'rxjs/operators';
import { ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';
import { ToastrHelperService } from 'src/services/toast-helper.service';


@Component({
  templateUrl: './data-setup.component.html',
  styleUrls: ['./data-setup.component.scss'],
  selector: 'app-data-setup',
})
export class DataSetupComponent implements OnInit, OnDestroy {
  @ViewChild('formCtrl') formCtrl: NgForm;

  public phonePattern = new RegExp('^[1-9][0-9]*$');
  public mdn: string;
  public isLoggedIn = false;
  public os: string;
  public networkType: string;
  public userPlan: IUserPlan;
  public deviceName: string;
  public isIos = false;
  public userPlanId: string;

  private alive = true;
  private userPlanID: string;

  constructor(
    public router: Router,
    public toastHelper: ToastrHelperService,
    private simpleAuthService: SimpleAuthService,
    private route: ActivatedRoute,
    private userPlansService: UserPlansService,
    private userDeviceService: UserDeviceService,
    private appState: AppState) { }

  ngOnInit(): void {
    this.simpleAuthService.userState.pipe(takeWhile(() => this.alive)).subscribe((authState) => this.isLoggedIn = !!authState && !authState.isAnonymous);
    this.route.params.pipe(takeWhile(() => this.alive)).subscribe((params: Params) => {
      if (!!params[ROUTE_URLS.PARAMS.USER_PLAN_ID]) {
        this.os = params[ROUTE_URLS.PARAMS.PHONE_OS] || 'ios';
        this.userPlanID = params[ROUTE_URLS.PARAMS.USER_PLAN_ID];
        this.userPlansService.getUserPlan(this.userPlanID).then((userPlan) => this.userPlanSelected(userPlan));
      }
      if (!!params && params[ROUTE_URLS.PARAMS.PHONE_NUMBER]) {
        this.mdn = params[ROUTE_URLS.PARAMS.PHONE_NUMBER];
      }
      if (!!params && params[ROUTE_URLS.PARAMS.PHONE_OS] && !!params[ROUTE_URLS.PARAMS.NETWORK]) {
        this.os = params[ROUTE_URLS.PARAMS.PHONE_OS];
        this.networkType = params[ROUTE_URLS.PARAMS.NETWORK];
        if (this.os === 'ios') {
          this.isIos = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  public checkPhoneCompatibility(): void {
    this.formCtrl.form.markAllAsTouched();
    if (!!this.formCtrl.valid) {
      this.appState.loading = true;
      this.userDeviceService.checkDeviceNetworkByMdn(this.mdn).then((result) => {
        this.appState.loading = false;
        if (!!result) {
          if (this.os === 'ios') {
            this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_IPHONE}`]);
          } else {
            this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_ANDROID}`]);
          }
          // if (result?.network?.toLowerCase() === 'att') {
          //   if (this.os === 'ios') {
          //     this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_IPHONE}`]);
          //   } else {
          //     this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_ANDROID}`]);
          //   }
          // }
          // else {
          //   if (this.os === 'ios') {
          //     this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TMO_IPHONE}`]);
          //   } else {
          //     this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.TMO_Android}`]);
          //   }
          // }
        } else {
          this.appState.loading = false;
          this.toastHelper.showWarning('An error has occured! Please try again later')
        }
      }, (error) => this.notCompatibleDevice(error));
    }
  }

  public userPlanSelected(userPlan: IUserPlan): void {
    if (!!userPlan && !!userPlan.planDevice) {
      this.userPlan = userPlan;
      this.userPlanID = userPlan.id;
      this.deviceName = userPlan.planDevice.marketingName || userPlan.planDevice.brand;
      this.networkType = userPlan.planDevice.networkType.toLowerCase();
      if (!this.route.firstChild) {
        this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.DATA_SETUP}`]);
      }
    }
  }

  public notCompatibleDevice(response: any): void {
    const errorMessage = response.message || response;
    console.warn('Device not supported', errorMessage);
    this.toastHelper.showWarning(errorMessage);
    if (!this.userPlanId) {
      this.userDeviceService.setCompatibleDevice(null);
    }
    this.appState.loading = false;
  }
}
